import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

import ValidationInfo from './ValidationInfo'
import ValidationText from './ValidationText'
import FormGroup from './FormGroup'

const DEFAULT_VAL = '---AttributedListInput---select---'

class Item extends Component {

  static propTypes = {
    attr: PropTypes.string,
    disabled: PropTypes.bool,
    hideAttribute: PropTypes.bool,
    index: PropTypes.number,
    itemData: PropTypes.object,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])
  }

  @autobind
  handleClickRemove() {
    if (this.props.onRemove) {
      this.props.onRemove({
        target: {
          value: this.props.value
        }
      })
    }
  }

  @autobind
  handleChange(e) {
    e.preventDefault()
    e.stopPropagation()
    const { target: { value, name } } = e
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          index: this.props.index,
          value,
          name
        }
      })
    }
  }

  render() {

    const {
      attr,
      value,
      hideAttribute,
      itemData,
      type,
      placeholder,
      required,
      disabled,
      readOnly,
      index
    } = this.props

    return (
      <div
        key={value}
        className="attributed-select-row row clearfix"
        onChange={this.handleChange}
      >
        <div className={`col-xs-${hideAttribute ? 9 : 5}`}>
          {itemData.title}
          <input
            type="hidden"
            name="id"
            value={value}
            disabled={disabled}
            readOnly={readOnly}
          />
        </div>

        {
          hideAttribute
            ? null
            : (
              <div className="col-xs-4">
                <input
                  className="form-control"
                  type={type}
                  name="attr"
                  id={`${itemData.title}-${index}-attr`}
                  placeholder={placeholder}
                  required={required}
                  value={attr}
                  disabled={disabled}
                  readOnly={readOnly}
                  autoFocus
                />
              </div>
            )
        }
        <div className="col-xs-3 text-right">
          {readOnly || disabled
            ? null
            : (
              <button
                className="btn btn-link"
                onClick={this.handleClickRemove}
              >
                <i className="glyphicon glyphicon-trash" />
              </button>
            )}
        </div>
      </div>
    )
  }
}

export default
class AttributedListInput extends Component {

  static propTypes = {
    className: PropTypes.string,
    columns: PropTypes.number,
    disabled: PropTypes.bool,
    helpText: PropTypes.string,
    hideAttribute: PropTypes.bool,
    info: PropTypes.string,
    isValid: PropTypes.oneOfType([
      PropTypes.shape({
        errors: PropTypes.oneOfType([
          PropTypes.array,
          PropTypes.object,
        ]),
        valid: PropTypes.bool
      }),
      PropTypes.bool
    ]),
    label: PropTypes.string,
    list: PropTypes.array,
    name: PropTypes.string,
    note: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    size: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.array,
  }

  constructor(props) {
    super(props)
    this.state = {
      values: props.value || []
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      values: newProps.value || []
    })
  }

  @autobind
  handleChange(e) {
    e.preventDefault()
    e.stopPropagation()
    const { target: { value } } = e

    if (value !== DEFAULT_VAL) {
      const values = [
        ...this.state.values,
        {
          value: value * 1,
          attr: undefined
        }
      ]
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: values
          }
        })
      }
    }

  }

  @autobind
  handleItemChange({ target: { value, name, index } }) {

    const item = {
      ...this.state.values[index],
      [name]: value
    }

    const values = [
      ...this.state.values.slice(0, index),
      item,
      ...this.state.values.slice(index + 1)
    ]

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: values
        }
      })
    }

  }

  @autobind
  handleRemoveItem({ target: { value } }) {

    const item = this.state.values.find((val) => val.value === value)
    const index = this.state.values.indexOf(item)

    const values = [
      ...this.state.values.slice(0, index),
      ...this.state.values.slice(index + 1),
    ]

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: values
        }
      })
    }

  }

  render() {
    const {
      className = '',
      columns,
      list,
      helpText,
      hideAttribute,
      info,
      note,
      isValid,
      label,
      name,
      required,
      size = 8,
      type = 'text',
      // value,
      placeholder,
      disabled,
      readOnly
    } = this.props

    const validValues = this.state.values
      .map((value, index) => ({
        ...value,
        index,
        itemData: list.find((itm) => itm.id === value.value)
      }))
      .filter(({ itemData }) => !!itemData)

    const existingKeys = validValues.map((value) => value.value)
    const remainingEntries = list.filter(({ id }) => existingKeys.indexOf(id) === -1)

    const select = (
      <select
        className="form-control"
        name={`${name}[0][id]`}
        id={name}
        onChange={this.handleChange}
        value={DEFAULT_VAL}
        disabled={disabled}
        readOnly={readOnly}
      >
        <option value={DEFAULT_VAL}>
          {!validValues.length ? '-- Bitte auswählen --' : '-- Weitere auswählen --'}
        </option>

        {remainingEntries.map((entry) => (
          <option
            key={`attributed-list-${entry.id}`}
            value={entry.id}
          >
            {entry.title}
          </option>
        ))}

      </select>
    )

    let selectBox = null

    if (remainingEntries.length) {
      selectBox = select
    }

    return (
      <FormGroup
        label={label}
        name={name}
        info={info}
        note={note}
        className="attributed-list-input"
      >
        <div className={`col-xs-${size} ${className}`}>

          <div className={`existing-values ${columns ? `columns-${columns}` : ''}`}>
            {validValues
              .map(({
                value, attr, index, itemData
              }) => (
                <Item
                  itemData={itemData}
                  index={index}
                  key={value}
                  attr={attr}
                  value={value}
                  hideAttribute={hideAttribute}
                  list={list}
                  type={type}
                  placeholder={placeholder}
                  required={required}
                  onRemove={this.handleRemoveItem}
                  disabled={disabled}
                  readOnly={readOnly}
                  onChange={this.handleItemChange}
                />
              ))}
          </div>

          {selectBox}

          {
            helpText
              ? <div className="help-block">{helpText}</div>
              : null
          }

          <ValidationText isValid={isValid}>
            <ValidationInfo isValid={isValid} />
          </ValidationText>

        </div>
      </FormGroup>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/AttributedListInput.js